module.exports = __webpack_public_path__ + "img/lesson_10.70fb1597.jpg";